import { errorFormResponsEvent, successFormResponsEvent } from './request_form.analytics'

function backToForm(flashMessageError) {
  const backErrorButton = flashMessageError.querySelector('.js-back-to-form')
  backErrorButton.addEventListener('click', e => {
    window.location.reload()
  })
}

export function initSubmitFormRequest() {
  const forms = document.querySelectorAll('.js-utag-form-request')

  const contactPage = document.querySelector('.js-contact-us')

  if (!forms.length) {
    return
  }
  forms.forEach(form => {

    form.addEventListener('submit', event => {

      let flashMessageContainer, flashMessageText, flashMessageSuccess, flashMessageError
      let flashMessageAlert

      if (contactPage) {
        flashMessageContainer = contactPage.querySelector('.js-flash-message-container')
        flashMessageText = flashMessageContainer.querySelector('.js-flash-message-text')
        flashMessageSuccess = flashMessageContainer.querySelector('.js-flash-message-success')
        flashMessageError = flashMessageContainer.querySelector('.js-flash-message-error')
      } else {
        flashMessageContainer = form.querySelector('.js-flash-message')
        flashMessageAlert = flashMessageContainer.querySelector('.js-flash-alert')
        flashMessageText = flashMessageContainer.querySelector('.js-flash-message-text')
      }

      event.preventDefault()

      const actionUrl = event.target.action
      const formData = new FormData(form)
      const formName = form.getAttribute('data-form-name')

      // Obtener el valor del campo _method si existe
      const methodField = form.querySelector('input[name="_method"]')
      const method = methodField ? methodField.value : form.method

      fetch(actionUrl, {
        method: method.toUpperCase(),
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      })
        .then(response => {
          if (response.ok) {
            return response.json()
          }
          return response.json().then(error => {
            throw new Error(error.error)
          })
        })
        .then(data => {
          if (data.status === 200 || data.status === 'ok') {
            successFormResponsEvent(form, formName)

            if (contactPage) {
              form.classList.add('hidden')
              flashMessageContainer.classList.remove('hidden')
              flashMessageSuccess.classList.remove('hidden')
              flashMessageText.innerHTML = data.message
            } else {
              flashMessageContainer.classList.remove('hidden')
              flashMessageAlert.classList.add('alert-success')
              flashMessageText.innerHTML = data.message
            }

          } else if (data.status === 500) {
            if (contactPage) {
              form.classList.add('hidden')
              flashMessageContainer.classList.remove('hidden')
              flashMessageError.classList.remove('hidden')
              backToForm(flashMessageError)
            } else {
              flashMessageContainer.classList.remove('hidden')
              flashMessageAlert.classList.add('alert-danger')
              flashMessageText.innerHTML = data.message
            }

            errorFormResponsEvent(form, formName)
          }
        })
        .catch(error => {
          if (contactPage) {
            form.classList.add('hidden')
            flashMessageContainer.classList.remove('hidden')
            flashMessageError.classList.remove('hidden')
            backToForm(flashMessageError)
          } else {
            flashMessageContainer.classList.remove('hidden')
            flashMessageAlert.classList.add('alert-danger')
            flashMessageText.innerHTML = error.message
          }

          errorFormResponsEvent(form, formName)
        })
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initSubmitFormRequest()
})